export enum Role {
	ADMIN = 'ADMIN',
	SUPORTE = 'SUPORTE',
	USER = 'USER'
}

export interface User {
	id: string;
	name: string;
	email: string;
	role: Role;
	balance: number;
	pricePerQuery: number;
	// Leilão: liberado individualmente pelo admin. Preços null = padrão global.
	leilaoEnabled: boolean;
	leilaoPriceToday: number | null;
	leilaoPriceOld: number | null;
	active: boolean;
	createdAt?: string;
	indicatorId?: string | null;
	indicator?: { id: string; name: string } | null;
}

export interface CreateUserPayload {
	name: string;
	email: string;
	password: string;
	role?: Role;
	pricePerQuery?: number;
	indicatorId?: string | null;
}

// Configuração do leilão do cliente. Campo ausente não é alterado; preço null
// limpa o override e devolve o cliente ao padrão global.
export interface UpdateLeilaoPayload {
	leilaoEnabled?: boolean;
	leilaoPriceToday?: number | null;
	leilaoPriceOld?: number | null;
}

export interface UpdateUserPayload {
	name?: string;
	email?: string;
	role?: Role;
	indicatorId?: string | null;
}
